import Analytics from "Helper/Analytics";
var initializeNavigation = function () {
    Analytics.bindNaviClickAsync();
    Analytics.bindFooterClickAsync();
};
export default initializeNavigation;
